import { render, staticRenderFns } from "./MobileGeneralInfo.vue?vue&type=template&id=23d8e52c"
import script from "./MobileGeneralInfo.vue?vue&type=script&lang=js"
export * from "./MobileGeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports